import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <span>&copy; Moment {new Date().getFullYear()}</span>
    </div>
  );
};

export default Footer;
